import * as React from 'react';
import { flow } from 'lodash';
import {formValueSelector, reduxForm, submit} from 'redux-form';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import ClaimsModalForm from './components/ClaimsModalForm';
import { bindActionCreators } from 'redux';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { push } from 'react-router-redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IAuthState } from '../../../../services/auth/models';
import {IPolicy} from '../../../../data/api/models';
import {DATE_FORMAT} from '../../../../util/helpers';
import moment = require('moment');

interface IClaimsModalProps {
  auth: IAuthState;
  quote: IQuoteState;
  btnClassName: string[];
  actions: {
    submit(name: string);
    push(path: string);
    quote: IQuoteActions;
    auth: IAuthActions;
  };
  policy: IPolicy;
}

interface IClaimsModalState {
  isSaved: boolean;
  showClaimsModal: boolean;
  isSubmitting: boolean;
}

class ClaimsModal extends React.Component<IClaimsModalProps, IClaimsModalState> {
  public state = {
    isSubmitting: false,
    isSaved: false,
    showClaimsModal: false,
  };

  private openSaveQuoteModal = () => {
    this.setState({
      showClaimsModal: true,
    });
  }

  private handleSubmit = ({password, passwordConfirmation}) => {
    const { actions } = this.props;
    this.setState({
      isSubmitting: true,
    });

    actions.quote.addClaim().then((response) => {
      this.setState({
        isSaved: true,
        isSubmitting: false,
      });
    });
  }

  private handleCloseModal = () => {
    const { dispatch, change, policy } = this.props;

    this.setState({
      showClaimsModal: false,
      isSaved: false,
      isSubmitting: false,
    });

    dispatch(change('claim', {
      policy,
    }));
  }

  public render() {
    const { policy, btnClassName } = this.props;
    const { showClaimsModal, isSaved, isSubmitting } = this.state;

    const minDate = moment(policy.commencesAt, DATE_FORMAT);
    if (moment().isBefore(minDate)) {
      return null;
    }

    return (
      <span>
        <Button
          onClick={this.openSaveQuoteModal}
          className={'btn btn-secondary red' + btnClassName.join(' ')}
        >
          Déclarer un sinistre
        </Button>

        <Modal show={showClaimsModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Déclarer un sinistre</Modal.Title>
          </Modal.Header>
          <ClaimsModalForm
            policy={policy}
            onSubmit={this.handleSubmit}
            onCloseModal={this.handleCloseModal}
            isSaved={isSaved}
            isSubmitting={isSubmitting}
          />
        </Modal>
      </span>
    );
  }

}

let selector;

export default flow([
  reduxForm({
    form: 'claims',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('claims');

    return component;
  },
  connect(
    (state) => {
      return {
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        submit: bindActionCreators(submit, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        dispatch,
      },
    }),
  ),
])(ClaimsModal);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/ClaimsModal/index.tsx